import React from "react";
import { Outlet, useParams } from "react-router";
import { useProfile } from "hooks";

/**
 * Get Profile
 */
const Profile = () => {
  const { id } = useParams();
  const { data, loading, error } = useProfile({ profileId: id });

  return <Outlet context={[id, data, loading, error]} />;
};

export default Profile;
